import React, { useState } from "react";
import { useLang } from "../../context/LangContext";
import { useAuth } from "../../context/AuthContext";
import { useSettings } from "../../context/SettingsContext";
import { useNavigate } from "react-router-dom";
import {
  BookingsTab,
  HousesTab,
  FeaturesTab,
  GalleryTab,
  SettingsTab,
  ContactsTab,
} from "./tabs";
import { LogOut, Calendar, Home, Sparkles, Image as ImageIcon, Settings as SettingsIcon, MessageSquare } from "lucide-react";

const TABS = [
  { key: "bookings", icon: Calendar, label_mn: "Захиалга", label_en: "Bookings" },
  { key: "houses", icon: Home, label_mn: "Байшингууд", label_en: "Houses" },
  { key: "features", icon: Sparkles, label_mn: "Үйлчилгээ", label_en: "Features" },
  { key: "gallery", icon: ImageIcon, label_mn: "Галлерей", label_en: "Gallery" },
  { key: "contacts", icon: MessageSquare, label_mn: "Мессежүүд", label_en: "Messages" },
  { key: "settings", icon: SettingsIcon, label_mn: "Тохиргоо", label_en: "Settings" },
];

export default function AdminDashboardPage() {
  const { lang } = useLang();
  const { user, logout } = useAuth();
  const { settings, refresh } = useSettings();
  const nav = useNavigate();
  const [tab, setTab] = useState("bookings");

  if (user === null) {
    return null;
  }

  return (
    <section className="pt-28 md:pt-28 pb-20 max-w-7xl mx-auto px-5 md:px-10" data-testid="admin-dashboard">
      <div className="flex items-center justify-between mb-8">
        <div>
          <span className="text-xs tracking-[0.3em] uppercase opacity-60 block mb-1">Admin</span>
          <h1 className="font-serif text-4xl md:text-5xl">Dashboard</h1>
        </div>
        <button
          className="btn btn-ghost btn-sm"
          onClick={async () => {
            await logout();
            nav("/admin/login");
          }}
          data-testid="admin-logout-btn"
        >
          <LogOut size={14} /> {lang === "mn" ? "Гарах" : "Logout"}
        </button>
      </div>

      <div className="grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <nav className="card p-2 sticky top-28">
            {TABS.map((tm) => {
              const Icon = tm.icon;
              const active = tab === tm.key;
              return (
                <button
                  key={tm.key}
                  onClick={() => setTab(tm.key)}
                  className="w-full text-left px-3 py-2.5 rounded-lg flex items-center gap-2.5 transition-colors text-sm"
                  style={{
                    background: active ? "var(--primary)" : "transparent",
                    color: active ? "var(--primary-fg)" : "var(--fg)",
                  }}
                  data-testid={`tab-${tm.key}`}
                >
                  <Icon size={15} />
                  {tm[`label_${lang}`]}
                </button>
              );
            })}
          </nav>
        </aside>
        <div className="lg:col-span-9 min-h-[400px]">
          {tab === "bookings" && <BookingsTab lang={lang} />}
          {tab === "houses" && <HousesTab lang={lang} />}
          {tab === "features" && <FeaturesTab lang={lang} />}
          {tab === "gallery" && <GalleryTab lang={lang} settings={settings} refresh={refresh} />}
          {tab === "contacts" && <ContactsTab lang={lang} />}
          {tab === "settings" && <SettingsTab lang={lang} settings={settings} refresh={refresh} />}
        </div>
      </div>
    </section>
  );
}
